import { layout } from 'thewest/App.routing'
import { StaticRoutes, createPageDefinition } from 'common/routing/page-definition'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { metrics } from 'component-library/__styling/settings'

export const westlive: StaticRoutes<typeof layout, TheWestSection> = {
    '/the-west-live': ({ getAdTargeting, store, config }) => {
        if (!isFeatureEnabled(store.getState().toggles, 'the-west-live')) {
            return null
        }

        const canonicalUrl = config.publicUrl + '/the-west-live'

        return createPageDefinition<typeof layout, TheWestSection>(
            {
                heading: 'The West Live',
                pageType: 'static',
                hideHeading: true,
                refreshOnInactive: true,
                pageMeta: {
                    title: 'The West Live',
                    description: 'The West Live',
                    link: [{ rel: 'canonical', href: canonicalUrl }],
                },
                adTargeting: getAdTargeting('the-west-live', 'default', 'the-west-live'),
                section: 'default',
            },
            layout.composition({
                type: 'zeus',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    horizontalGutters: true,
                    hasBackgroundFill: true,
                    stretchSelf: true,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'box',
                            props: {
                                verticalSpacing: 'lg',
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'the-west-live-player-page',
                                        props: {},
                                    }),
                                ],
                            },
                        }),
                        layout.component({
                            type: 'ad-unit',
                            props: {
                                noticePosition: 'none',
                                padding: [0, 0, metrics.thewest.margins.md, 0],
                                slot: {
                                    id: 'leaderboard-one',
                                    size: 'leaderboardResponsive',
                                    pageType: 'static',
                                },
                            },
                        }),
                        layout.component({
                            type: 'link-banner',
                            props: {
                                url: `https://emails.thewest.com.au/subscribe/index.html?utm_source=${canonicalUrl}&utm_campaign=ArticleLinkBanner&utm_content=ArticleLinkBanner`,
                                message: 'Get the latest news from thewest.com.au in your inbox.',
                                cta: 'Sign up for our emails',
                                verticalGutters: ['md', 'lg'],
                            },
                        }),
                        layout.component({
                            type: 'related-content',
                            props: {
                                dataDefinitionArgs: {
                                    type: 'curation',
                                    name: 'home',
                                    offset: 0,
                                    pageSize: 3,
                                },
                            },
                        }),
                    ],
                    sidebar: [
                        layout.component({
                            type: 'ad-unit',
                            props: {
                                noticePosition: 'none',
                                padding: [0, 0, metrics.thewest.margins.md, 0],
                                slot: {
                                    id: 'sidebar-top',
                                    size: 'desktopMrecHalfPage',
                                    pageType: 'static',
                                },
                            },
                        }),
                        layout.nestedComposition({
                            type: 'box',
                            props: {
                                stickyOffset: 350,
                                fillContainer: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'ad-unit',
                                        props: {
                                            noticePosition: 'none',
                                            padding: [0, 0, metrics.thewest.margins.md, 0],
                                            slot: {
                                                id: 'sidebar-middle',
                                                size: 'desktopMrec',
                                                pageType: 'static',
                                            },
                                        },
                                    }),

                                    layout.component({
                                        type: 'juliet',
                                        props: {
                                            cardType: {
                                                type: 'landscape',
                                                format: 'landscape-smallImage',
                                            },
                                            removeHorizontalGutters: true,
                                            hideKicker: true,
                                            contentIsTangential: true,
                                            sectionHeader: {
                                                heading: 'Top Stories',
                                                section: 'generic',
                                            },
                                            dataDefinitionArgs: {
                                                type: 'curation',
                                                name: 'home',
                                                offset: 0,
                                                pageSize: 3,
                                            },
                                        },
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            })
        )
    },
}
